import { useState } from 'react'
import { Field } from 'react-final-form'
import helpers, { CAMPAIGN_NAME_LIMIT } from 'workflow/utils/helpers'

import FormItem from 'common/components/FormItem'
import Input from 'common/components/Input'
import { stripForbiddenCharacters } from 'common/helpers/stripForbiddenCharacters'

const validateName = (value: string | undefined) => {
  if (!value?.trim()) {
    return 'Enter a name for your workflow.'
  }
  const { validationError } = helpers.validateCampaignName(value)
  return validationError
}
const WorkFlowName = () => {
  const [error, setError] = useState<string | undefined>()

  return (
    <div className="flex flex-col p-6 w-134.5">
      <div className="text-xl font-medium text-coolGray-800">
        Name of workflow
      </div>
      <p className="text-sm text-coolGray-500 mb-4">
        Your workflow will include all of your selected templates in the panel
        below.
      </p>
      <Field<string>
        name="workflowName"
        validate={validateName}
        parse={(value) => {
          const strippedValue = stripForbiddenCharacters(value)
          const { isValid, validationError } =
            helpers.validateCampaignName(strippedValue)

          if (isValid) {
            setError(undefined)
            return strippedValue
          } else {
            setError(validationError)
            return strippedValue.slice(0, -1)
          }
        }}
      >
        {({ input, meta }) => (
          <FormItem
            error={meta.touched ? meta.error || error : undefined}
            className="flex-none mr-6 mb-4"
          >
            <Input
              data-cy="workflow-name-input"
              autoFocus
              type="text"
              variant="default"
              className="w-full focus:bg-orange-50"
              value={input.value}
              onChange={input.onChange}
              onBlur={input.onBlur}
              id="workflowName"
              name="workflowName"
              placeholder="Select a memorable name"
              maxLength={CAMPAIGN_NAME_LIMIT}
            />
          </FormItem>
        )}
      </Field>
    </div>
  )
}

export default WorkFlowName
